import { gtmData } from 'constants/gtm';

declare global {
    interface Window {
        __GTM?: string;
    }
}

/** Установка данных GTM в константы из window */
export function bootstrapGtm() {
    if (window.__GTM) {
        gtmData.id = window.__GTM;
        delete window.__GTM;
    }
}
